// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tlgkyluncdtmytiddmlf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRsZ2t5bHVuY2R0bXl0aWRkbWxmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUyMDAzNDIsImV4cCI6MjA3MDc3NjM0Mn0.A5YrOag9YAawGVmRxSs1phDBXSxiYqrJkV7GmcFsnS8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});